<template>
  <div v-html="fontCss" />
  <!--
  <span v-for="font in fonts" :style="`font-family: ${font}; margin-right: 1em;`">{{font}}</span>
  -->
</template>

<script>
import {getFonts} from '@/services/design'
import flatten from 'flatten'
import WebFont from 'webfontloader'

export default {
  props: ["design"],
  data() {
    return {fontCss: '', fontLoading: null}
  },
  computed: {
    designId() {
      return this.design && this.design.id;
    },
    fonts() {
      return this.design && flatten(this.design.fonts)
    }
  },
  watch: {
    async designId(val) {
      this.requestFonts()
    },
    fonts(val) {
      this.lookForFonts()
    }
  },
  methods: {
    async requestFonts() {
      console.log('requestFonts');
      if (!this.design) return console.log('No designId');;
      try {
        var result = await getFonts(this.designId);
        this.fontCss = '<style>' + result + '</style>';
      } catch(e) {
        console.error('font-load-error:', e);
        this.$emit('font-load-error', e);
      }
    },
    lookForFonts() {
      console.log('lookForFonts', this.fonts);
      if (!this.design) return;

      // Time out in 1.5 seconds. This is a short time, but the user (currently)
      // sees a blank screen when loading for those 1.5 seconds. It will be expected
      // for this to fire, and then the fonts-loaded to fire.
      this.fontLoading = setTimeout(() => this.$emit('font-load-error', 'timeout'), 1500);

      WebFont.load({
        custom: {
          families: this.fonts
        },
        active: () => {
          clearTimeout(this.fontLoading);
          this.$emit('fonts-loaded');
        }
      })
    }
  },
  async mounted() {
    await this.requestFonts()
    await this.lookForFonts()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/EditorFonts.vue